import { ReactNode } from 'react';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import { StyledVisitHeader, StyledVisitHeaderDetails, StyledVisitHeaderPatientContent } from './VisitHeader.styled';

type VisitHeaderProps = {
   readonly title?: ReactNode;
   readonly details?: ReactNode;
   readonly actions?: ReactNode;
};

export const VisitHeader = (props: VisitHeaderProps): JSX.Element => {
   return (
      <StyledVisitHeader {...appendTestableElementAttributes('visitHeader')}>
         <StyledVisitHeaderPatientContent>
            {props.title}
            <StyledVisitHeaderDetails>{props.details}</StyledVisitHeaderDetails>
         </StyledVisitHeaderPatientContent>
         {props.actions}
      </StyledVisitHeader>
   );
};
